import { createFileRoute } from '@tanstack/react-router'
import { GoalRefinementView } from '../../../../components/goals/GoalRefinementView'

export const Route = createFileRoute('/_authenticated/goals/$goalId/refine')({
  component: GoalRefinementDetail,
  staticData: { suppressNotifications: true },
})

function GoalRefinementDetail() {
  const { goalId } = Route.useParams()

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <GoalRefinementView goalId={goalId} />
      </div>
    </div>
  )
}
